import { render, staticRenderFns } from "./CheckBoxSelect.vue?vue&type=template&id=12233787"
import script from "./CheckBoxSelect.vue?vue&type=script&lang=js"
export * from "./CheckBoxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports